<template>
  <b-form class="needs-validation" @submit.prevent="submitForm">
    <b-card no-body>
      <b-card-header>
        <b-card-title>Ruangan</b-card-title>
        <b-card-title class="text-primary">
          <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="secondary" class="btn-icon"
            :to="{ name: 'bRuangan' }">
            <feather-icon icon="ArrowLeftIcon" />
          </b-button>
        </b-card-title>
      </b-card-header>

      <b-card-body>
        <b-row>
          <b-col md="10" offset-md="1">
            <template v-if="action == 'detail'">
              <b-form-group label="Nama PD/UKPD Pemilik KIB C" label-for="kolok" label-class="pb-0 pt-0">
                <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                  <v-select id="kolok" v-model="kolokGedung" :options="kolokOptions" label="text" :disabled="true"
                    @input="inputKolok" />
                  <small v-for="(error, index) of v$.kolok_gedung.$errors" :key="index" class="text-danger">
                    {{ error.$message }}
                  </small>
                </b-overlay>
              </b-form-group>
            </template>
            <template v-else>
              <b-form-group label="Nama PD/UKPD Pemilik KIB C" label-for="kolok" label-class="pb-0 pt-0">
                <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                  <v-select id="kolok" v-model="v$.kolok.$model" :options="kolokOptions" label="text"
                    :disabled="action == 'update' || action == 'detail'" @input="inputKolok" />
                  <small v-for="(error, index) of v$.kolok.$errors" :key="index" class="text-danger">
                    {{ error.$message }}
                  </small>
                </b-overlay>
              </b-form-group>
            </template>
            <b-form-group label="Guid Aset" label-for="register" label-class="pb-0 pt-0">
              <b-overlay :show="isLoadRegister" variant="light" opacity="0.85" blur="2px" rounded="sm">
                <v-select id="register" v-model="v$.register.$model" :options="registerOptions" label="text"
                  :disabled="action == 'update' || action == 'detail'" @input="inputRegister" />
                <small v-for="(error, index) of v$.register.$errors" :key="index" class="text-danger">
                  {{ error.$message }}
                </small>
              </b-overlay>
            </b-form-group>
            <template v-if="action == 'detail'">
              <b-form-group label="Kode dan Nama Barang" label-for="Kode dan Nama Barang" label-class="pb-0 pt-0">
                <b-form-input id="kode_nama_barang" :value="dataDetail.kobar_108+ '::'+ dataDetail.nabar_108" disabled />
              </b-form-group>
            </template>
            <template v-else>
              <b-row>
                <b-col v-for="(item, index) of field" :key="index" :cols="item.col || '12'">
                  <b-form-group :label="item.label" :label-for="item.id" label-class="pb-0 pt-0">
                    <b-form-input :id="item.id" :value="item.value" disabled />
                  </b-form-group>
                </b-col>
              </b-row>
            </template>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card v-for="(item, index) of v$.lantai.$model" :key="index" no-body>
      <b-card-header>
        <b-card-title />
        <b-card-title v-if="action != 'detail'">
          <b-button v-if="index == lantai.length - 1" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
            class="btn-icon" @click="() => lantai.push({
              value: null, ruangan: [
                {
                  kode: defaultValue,
                  nama: '',
                },
              ],
            })">
            <feather-icon icon="PlusIcon" />
            Tambah Lantai
          </b-button>
          <b-button v-else v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="btn-icon"
            @click="clickHapusLantai(index)">
            <feather-icon icon="MinusIcon" />
            Hapus Lantai
          </b-button>
        </b-card-title>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="10" offset-md="1">
            <b-form-group label="Lantai" label-class="pb-0 pt-0" label-for="lantai">
              <b-form-select v-model="item.value" :options="lantaiOptions" :state="validateState2(
                v$.lantai.$each.$response.$data[
                  index
                ].value
              )" :disabled="action == 'detail'" />
              <b-form-invalid-feedback v-for="(error, index2) of v$.lantai.$each.$response.$errors[index].value"
                :key="index2">
                {{ error.$message }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-row v-for="(itemRuangan, index2) of item.ruangan" :key="index2">
              <b-col cols="5">
                <label for="kodeRuangan" class="d-block pb-0 pt-0">
                  Jenis Ruangan
                  <feather-icon v-b-tooltip.hover icon="AlertCircleIcon" class="text-warning"
                    title="Jika jenis ruangan tidak tersedia pada pilihan, maka dapat bermohon untuk penambahan jenis ruangan kepada BPAD" />
                </label>
                <v-select id="jenisRuangan" v-model="itemRuangan.kode" :options="jenisRuanganOptions" label="text"
                  :disabled="action == 'detail'" @input="e => inputJenisRuangan(e, index, index2)" />
                <div v-if="v$.lantai.$each.$response.$errors[index].ruangan[0]">
                  <small
                    v-for="(error, index3) of v$.lantai.$each.$response.$errors[index].ruangan[0].$response.$errors[index2].kode"
                    :key="index3" class="text-danger">
                    {{ error.$message }}
                  </small>
                </div>
              </b-col>
              <b-col cols="6">
                <b-form-group label="Nama Ruangan" label-class="pb-0 pt-0" label-for="namaRuangan">
                  <b-form-input v-model="itemRuangan.nama" :state="validateState2(
                    v$.lantai.$each.$response.$data[index].ruangan.$each.$data[index2].nama
                  )" :disabled="action == 'detail'" />
                  <div v-if="v$.lantai.$each.$response.$errors[index].ruangan[0]">
                    <small
                      v-for="(error, index3) of v$.lantai.$each.$response.$errors[index].ruangan[0].$response.$errors[index2].nama"
                      :key="index3" class="text-danger">
                      {{ error.$message }}
                    </small>
                  </div>
                </b-form-group>
              </b-col>
              <b-col v-if="action != 'detail'" cols="1" align-self="center" class="text-right">
                <b-button v-if="index2 == 0" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="btn-icon"
                  @click="() => lantai[index].ruangan.push({ kode: defaultValue, nama: '' })">
                  <feather-icon icon="PlusIcon" />
                </b-button>
                <b-button v-else v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="btn-icon"
                  @click="clickHapusRuangan(index, index2)">
                  <feather-icon icon="MinusIcon" />
                </b-button>
              </b-col>
            </b-row>
            <b-col cols="12" class="text-right pr-0 pt-2">
              <b-button v-if="lantai.length - 1 == index && action != 'detail'" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit" variant="primary" :disabled="isSubmit">
                <div v-if="isSubmit">
                  <b-spinner small />
                  <span class="sr-only">Loading...</span>
                </div>
                <div v-else>
                  Simpan
                </div>
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </b-form>
</template>

<script>
import {
  ref, computed, watchEffect, watch,
} from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {
  required,
  helpers,
} from '@vuelidate/validators'
import useVuelidate from '@vuelidate/core'
import apiMaster from '@/composables/master'
import apiGedung from '@/composables/b/gedung'
import apiLantai from '@/composables/master/lantai'
import apiJenisRuangan from '@/composables/master/jenisRuangan'
import apiRuangan from '@/composables/b/ruangan'
import { propsBoolean, propsObject, propsString } from '@/utils/propsTipeData'
import helper from '@/libs/helper'

export default {
  setup(props, context) {
    const g = context.root
    const { tahunNow } = helper

    const isShowData = ref(false)
    const isSubmit = ref(false)

    const kolokGedung = ref(helper.defaultValue)
    const kolok = ref(helper.defaultValue)
    const register = ref(helper.defaultValue)
    const kodeNamaBarang = ref('')
    const lantai = ref([
      {
        value: null,
        ruangan: [
          {
            kode: helper.defaultValue,
            nama: '',
          },
        ],
      },
    ])
    const removeRuangan = ref([])

    const kolokOptions = ref([helper.defaultValue])
    const registerOptions = ref([helper.defaultValue])
    const lantaiOptions = ref([helper.defaultValue])
    const jenisRuanganOptions = ref([helper.defaultValue])
    const tempData = ref({})

    const isLoadKolok = ref(false)
    const isLoadRegister = ref(false)

    watchEffect(() => {
      if (kolokOptions.value.length > 1) {
        tempData.value = props.dataDetail
      }
    })

    const field = computed(() => ([
      {
        label: 'Kode dan Nama Barang',
        id: 'kodeNamaBarang',
        value: kodeNamaBarang.value,
      },
    ]))

    const getPdUkpd = (searchPdUpd = '') => {
      const params = {
        tahun: tahunNow,
        cari: searchPdUpd,
      }
      return apiMaster.getPdUpd(g, params)
    }

    const getRegister = (kolokVal = null, kobarVal = '') => {
      const data = {
        filter_kobar: kobarVal,
        filter_kolok: kolokVal,
        limit: 100000000,
      }
      return apiGedung.getGedung(g, data)
    }

    const getLantai = () => apiLantai.getLantai(g)

    const getJenisRuangan = () => {
      const params = {
        limit: 1000000,
      }
      return apiJenisRuangan.getData(g, params)
    }

    const initData = async () => {
      isLoadKolok.value = true

      const [resultKolok, resultLantai, resultJenisRuangan] = await Promise.all([
        getPdUkpd(),
        getLantai(),
        getJenisRuangan(),
      ])

      resultKolok.unshift(helper.defaultValue)
      kolokOptions.value = resultKolok

      lantaiOptions.value = [helper.defaultValue, ...resultLantai.rows]

      jenisRuanganOptions.value = [helper.defaultValue, ...resultJenisRuangan.rows.map(item => ({ text: item.jenis_ruangan, value: item.id }))]

      isLoadKolok.value = false
    }

    initData()

    const requiredMsg = helper.requiredMessage
    const customRequiredObject = fieldName => ({
      checkField: helpers.withMessage(
        `${fieldName} ${requiredMsg}`,
        val => !!val.value,
      ),
    })

    const commonValidateRequired = fieldName => ({
      required: helpers.withMessage(
        `${fieldName} ${requiredMsg}`,
        required,
      ),
    })

    const $externalResults = ref({})
    const rules = computed(() => ({
      kolok_gedung: customRequiredObject('PD/UKPD Gedung'),
      kolok: customRequiredObject('PD/UKPD'),
      register: customRequiredObject('Register'),
      lantai: {
        $each: helpers.forEach({
          value: {
            unique: helpers.withMessage(
              'Lantai telah ada',
              val => {
                let countVal = 0
                for (let i = 0; i < lantai.value.length; i += 1) {
                  const item = lantai.value[i]
                  if (item.value == val) countVal += 1

                  if (countVal > 1) break
                }
                return !(countVal > 1)
              },
            ),
            ...commonValidateRequired('Lantai'),
          },
          ruangan: {
            $each: helpers.forEach({
              kode: customRequiredObject('Jenis ruangan'),
              nama: commonValidateRequired('Nama ruangan'),
            }),
          },
        }),
      },
    }))

    const fieldForm = {
      kolok,
      register,
      lantai,
    }

    const v$ = useVuelidate(
      rules,
      fieldForm,
      { $externalResults, $autoDirty: true },
    )

    const submitForm = async () => {
      isSubmit.value = true

      const isFormCorrect = await v$.value.$validate()
      // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
      if (!isFormCorrect) {
        console.log(v$.value)
        isSubmit.value = false
        return
      }

      const data = {
        kolok_gedung: kolokGedung.value.value,
        guid_aset: register.value.value,
        kolok: g.$cookies.get('kolok') || kolok.value.value,
        data_ruangan: lantai.value.map(item => ({
          lantai: item.value,
          ruangan: item.ruangan.map(itemRuangan => ({
            jenis_ruangan_id: itemRuangan.kode.value,
            nama_ruangan: itemRuangan.nama,
            ruangan_id: itemRuangan.id,
          })),
        })),
        username: g.$cookies.get('username'),
        remove_data_ruangan: removeRuangan.value,
      }

      await apiRuangan.submitRuangan(g, data)

      isSubmit.value = false
    }

    const setRegisterOptions = async kolokVal => {
      isLoadRegister.value = true

      const result = await getRegister(kolokVal)

      registerOptions.value = [
        helper.defaultValue,
        ...result.rows.map(item => {
          const additional = item.nm_spesifikasi_barang ? ` :: ${item.nm_spesifikasi_barang}` : ''
          return {
            text: `${item.noreg_108} :: ${item.alamat}${additional}`,
            value: item.guid_aset,
            ...item,
          }
        }),
      ]

      isLoadRegister.value = false
    }

    watch(tempData, () => {
      let index = kolokOptions.value.findIndex(item => item.value == tempData.value.kolok)
      let indexKolokGedung = kolokOptions.value.findIndex(item => item.value == tempData.value.kolok_gedung)
      if (index >= 0) {
        kolok.value = kolokOptions.value[index]
        if (kolokOptions.value[index].value) {
          setRegisterOptions(kolokOptions.value[index].value).then(() => {
            index = registerOptions.value.findIndex(item => item.value == tempData.value.register)

            if (index >= 0) {
              register.value = registerOptions.value[index]
              kodeNamaBarang.value = `${registerOptions.value[index].kobar_108} :: ${registerOptions.value[index].nabar_108}`
            } else {
              register.value = tempData.value.register ? { value: tempData.value.register, text: tempData.value.register } : helper.defaultValue
              kodeNamaBarang.value = ''
            }
          })
        }
      } else {
        kolok.value = helper.defaultValue
      }
      console.log(tempData.value.lantai)
      if (tempData.value.lantai) {
        lantai.value = tempData.value.lantai
      }
      if (indexKolokGedung >= 0) {
        kolokGedung.value = kolokOptions.value[indexKolokGedung]
      }
    })

    const inputKolok = e => {
      register.value = helper.defaultValue
      kodeNamaBarang.value = ''
      if (e) {
        if (e.value) {
          setRegisterOptions(e.value)
        } else registerOptions.value = [helper.defaultValue]
      } else {
        kolok.value = helper.defaultValue
        registerOptions.value = [helper.defaultValue]
      }
    }

    const inputRegister = async e => {
      if (e) {
        if (e.value) kodeNamaBarang.value = `${e.kobar_108} :: ${e.nabar_108}`
        else kodeNamaBarang.value = ''
      } else {
        register.value = helper.defaultValue
        kodeNamaBarang.value = ''
      }
    }

    const { validateState, validateState2 } = helper

    const clickHapusLantai = index => {
      const removedLantai = lantai.value.splice(index, 1)
      const tempRemovedLantai = [...removeRuangan.value]
      for (let i = 0; i < removedLantai.length; i += 1) {
        const item = removedLantai[i]

        const tempRemovedRuangan = []
        for (let j = 0; j < item.ruangan.length; j += 1) {
          const itemRuangan = item.ruangan[j]
          if (itemRuangan.id) {
            tempRemovedRuangan.push({
              ruangan_id: itemRuangan.id,
              jenis_ruangan_id: itemRuangan.kode,
              nama_ruangan: itemRuangan.nama,
            })
          }
        }
        if (tempRemovedRuangan.length > 0) {
          tempRemovedLantai.push({
            lantai: item.value,
            ruangan: tempRemovedRuangan,
          })
        }
      }
      removeRuangan.value = tempRemovedLantai
    }

    const clickHapusRuangan = (index, index2) => {
      const removedRuangan = lantai.value[index].ruangan.splice(index2, 1)
      const tempRemovedLantai = [...removeRuangan.value]
      const indexLantaiRemoved = tempRemovedLantai.findIndex(item => item.lantai == lantai.value[index].value)
      if (removedRuangan[0].id) {
        const tempRuangan = {
          ruangan_id: removedRuangan[0].id,
          jenis_ruangan_id: removedRuangan[0].kode,
          nama_ruangan: removedRuangan[0].nama,
        }

        if (indexLantaiRemoved >= 0) {
          tempRemovedLantai[indexLantaiRemoved].ruangan.push(tempRuangan)
        } else {
          tempRemovedLantai.push({
            lantai: lantai.value[index].value,
            ruangan: [tempRuangan],
          })
        }
      }
      removeRuangan.value = tempRemovedLantai
    }

    const inputJenisRuangan = (e, index, index2) => {
      if (!e) {
        lantai.value[index].ruangan[index2].kode = helper.defaultValue
      }
    }

    return {
      defaultValue: helper.defaultValue,
      v$,
      $externalResults,
      isShowData,
      isLoadKolok,
      isLoadRegister,
      isSubmit,
      kodeNamaBarang,
      removeRuangan,

      ...fieldForm,

      field,
      kolokOptions,
      registerOptions,
      lantaiOptions,
      jenisRuanganOptions,

      submitForm,
      validateState,
      inputKolok,
      inputRegister,
      inputJenisRuangan,
      validateState2,
      clickHapusLantai,
      clickHapusRuangan,
      kolokGedung,
    }
  },
  directives: {
    Ripple,
  },
  components: {
    vSelect,
  },
  props: {
    dataDetail: propsObject,
    action: propsString,
    isGetDetailVal: propsBoolean,
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-select.scss";
</style>
